import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { authCodeFlowConfig } from '../../../config/identity-server.config';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  constructor(
    private router: Router,
    private oauthService: OAuthService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Configure `angular-oauth2-oidc` with authentication settings
    this.oauthService.configure(authCodeFlowConfig);

    this.activatedRoute.queryParamMap.subscribe(params => {
      // If there’s a `code` in the URL (this mean that a user returned from Identity Server)
      if (params.get('code')) {
        this.oauthService.loadDiscoveryDocumentAndTryLogin().then(_ => {
          //  Completes login and redirects to the home page
          this.router.navigate(['/']);
        });
      } else {
        // If there’s no `code`, attempt automatic login
        this.oauthService.loadDiscoveryDocumentAndTryLogin().then(_ => {
          // If there’s no valid token, start login flow with `prompt=login`
          this.oauthService.initLoginFlow(undefined, {
            customQueryParams: {
              promt: 'login', // Forces re-authentication, even if there’s an active session
            },
          });
        });
      }
    });
  }
}
